var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4551_5606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2953 9.87107L19.9365 9.09582L16.6161 1.38562C16.3836 0.845744 15.6182 0.845744 15.3858 1.38562L12.0654 9.09576L3.70655 9.87107C3.12123 9.92532 2.88473 10.6533 3.3263 11.0413L9.63306 16.5816L7.78737 24.771C7.65812 25.3444 8.27743 25.7943 8.78281 25.4942L16.0009 21.2082L23.2191 25.4942C23.7245 25.7944 24.3437 25.3444 24.2145 24.771L22.3688 16.5816L28.6756 11.0413C29.1172 10.6533 28.8806 9.92532 28.2953 9.87107Z",
    fill: "#FFDC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45452 1.12015C7.88065 1.71202 9.0834 4.2539 9.77103 5.73528C9.87915 5.96816 9.58696 6.17853 9.4004 6.00209C8.21371 4.88009 6.18464 2.93309 5.75852 2.34115C5.42133 1.87284 5.52764 1.21984 5.99602 0.882647C6.46433 0.545459 7.11733 0.651834 7.45452 1.12015Z",
    fill: "#FFF082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5449 1.12015C24.1188 1.71202 22.916 4.2539 22.2284 5.73528C22.1203 5.96816 22.4125 6.17853 22.599 6.00209C23.7857 4.88009 25.8147 2.93303 26.2409 2.34115C26.5781 1.87284 26.4718 1.21984 26.0034 0.882647C25.5351 0.545459 24.8821 0.651834 24.5449 1.12015Z",
    fill: "#FFF082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2785 18.4769C30.5851 18.2507 27.7979 17.8772 26.1777 17.6722C25.9231 17.6399 25.8114 17.9822 26.0361 18.1064C27.4657 18.8961 29.9371 20.2376 30.6305 20.4637C31.1791 20.6426 31.7689 20.3429 31.9479 19.7942C32.1268 19.2456 31.8271 18.6558 31.2785 18.4769Z",
    fill: "#FFF082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72116 18.4769C1.41454 18.2507 4.20173 17.8772 5.82192 17.6722C6.07661 17.6399 6.18823 17.9822 5.96355 18.1064C4.53398 18.8961 2.06254 20.2376 1.36916 20.4637C0.820536 20.6426 0.230722 20.3429 0.0517843 19.7942C-0.127154 19.2456 0.172534 18.6558 0.72116 18.4769Z",
    fill: "#FFF082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9863 30.2694C14.9863 29.5401 15.4954 26.7745 15.8029 25.1705C15.8512 24.9184 16.2113 24.9184 16.2596 25.1705C16.5671 26.7745 17.0761 29.5401 17.0761 30.2694C17.0761 30.8465 16.6083 31.3143 16.0313 31.3143C15.4541 31.3144 14.9863 30.8465 14.9863 30.2694Z",
    fill: "#FFF082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8235 4.18938L16.6161 1.38562C16.3836 0.845744 15.6181 0.845744 15.3857 1.38562L12.0653 9.09576L3.70655 9.87107C3.12123 9.92532 2.88473 10.6533 3.3263 11.0413L9.63306 16.5817L7.78737 24.771C7.65812 25.3444 8.27743 25.7943 8.78281 25.4942L9.7435 24.9238C11.3184 14.7288 15.7461 7.24488 17.8235 4.18938Z",
    fill: "#FFC850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4551_5606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.665d2f35d3a7651b165103b4b01a09a3.svg";
export { ForwardRef as ReactComponent };